import { IconEdit } from '@calendly/ui/components/glyphs/IconEdit'
import { IconMapPin } from '@calendly/ui/components/glyphs/IconMapPin'
import { IconMessageQuestion } from '@calendly/ui/components/glyphs/IconMessageQuestion'
import { IconPhone } from '@calendly/ui/components/glyphs/IconPhone'
import {
  AskInviteeIcon,
  BlockIcon,
  EditPencilIcon,
  LocationPinIcon,
  PhoneIcon,
  QuestionCircleIcon,
  TypeCursorIcon
} from '@calendly/ui/components/icons'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import PropTypes from 'prop-types'

import AskInviteIcon from 'images/icons/ask-invitee-location.svg'
import CustomLocationIcon from 'images/icons/custom-location.svg'
import InboundCallIcon from 'images/icons/inbound-call.svg'
import LocationMarkerIcon from 'images/icons/location-marker.svg'
import OutboundCallIcon from 'images/icons/outbound-call.svg'
import GoogleMeetLogo from 'images/logos/google-meet.svg'
import GotomeetingSquareLogo from 'images/logos/gotomeeting-square.svg'
import GotomeetingLogo from 'images/logos/gotomeeting.svg'
import MsTeamsLogo from 'images/logos/ms-teams.svg'
import WebexLogo from 'images/logos/webex.svg'
import ZoomLogo from 'images/logos/zoom.svg'

const ICONS_FOR_KIND = {
  physical: LocationPinIcon,
  outbound_call: PhoneIcon,
  inbound_call: PhoneIcon,
  zoom_conference: ZoomLogo,
  ask_invitee: AskInviteeIcon,
  no_location: BlockIcon,
  custom: TypeCursorIcon,
  google_conference: GoogleMeetLogo,
  webex_conference: WebexLogo,
  microsoft_teams_conference: MsTeamsLogo,
  gotomeeting_conference: GotomeetingLogo
}

const ICONS_FOR_ONE_OFF_KIND = {
  physical: LocationMarkerIcon,
  google_conference: GoogleMeetLogo,
  zoom_conference: ZoomLogo,
  microsoft_teams_conference: MsTeamsLogo,
  webex_conference: WebexLogo,
  gotomeeting_conference: GotomeetingLogo,
  custom: CustomLocationIcon,
  ask_invitee: AskInviteIcon,
  inbound_call: InboundCallIcon,
  outbound_call: OutboundCallIcon
}

const NEW_ET_EDITOR_ICONS = {
  ...ICONS_FOR_KIND,
  ask_invitee: QuestionCircleIcon,
  custom: EditPencilIcon,
}

const CRUD_GLYPHS = {
  physical: IconMapPin,
  outbound_call: IconPhone,
  inbound_call: IconPhone,
  custom: IconEdit,
  ask_invitee: IconMessageQuestion,
}

const CRUD_ICONS = {
  gotomeeting_conference: GotomeetingSquareLogo,
}

const IconComponent = ({ Icon, ...props }) => (
  typeof Icon === 'string'
    ? <img src={Icon} alt="" {...props} />
    : <Icon {...props} />
)

export const LocationIcon = ({ kind, isOneOff = false, useNewIcons = false, useCrudIcons = false, ...props }) => {
  if (isOneOff) {
    return <IconComponent Icon={ICONS_FOR_ONE_OFF_KIND[kind]} {...props} />
  }

  const crudGlyph = useCrudIcons && CRUD_GLYPHS[kind]
  if (crudGlyph) {
    return <UiIcon icon={crudGlyph} size="small" title="" {...props} />
  }

  if (useCrudIcons && CRUD_ICONS[kind]) {
    return <IconComponent Icon={CRUD_ICONS[kind]} {...props} />
  }

  if (useNewIcons && NEW_ET_EDITOR_ICONS[kind]) {
    return <IconComponent Icon={NEW_ET_EDITOR_ICONS[kind]} {...props} />
  }

  return <IconComponent Icon={ICONS_FOR_KIND[kind]} {...props} />
}


LocationIcon.propTypes = {
  kind: PropTypes.string.isRequired,
  isOneOff: PropTypes.bool,
  useNewIcons: PropTypes.bool,
  useCrudIcons: PropTypes.bool,
  eventTypeKind: PropTypes.string
}
